import { render, staticRenderFns } from "./LocalsNested.vue?vue&type=template&id=5b4e4e68&scoped=true"
import script from "./LocalsNested.vue?vue&type=script&lang=js"
export * from "./LocalsNested.vue?vue&type=script&lang=js"
import style0 from "./LocalsNested.vue?vue&type=style&index=0&id=5b4e4e68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4e4e68",
  null
  
)

export default component.exports